const HEAD = document.getElementsByTagName('HEAD')[0];

export const makeScripts = (path: string[]): Promise<void> => {
    return new Promise(resolve => {
        const script = document.createElement('script');
        script.src = path[0];
        script.async = true;
        script.onload = () => {
            resolve();
        };
        HEAD.appendChild(script);
    });
}
